var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 37,
    viewBox: "0 0 99 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.838 36.9241H2.80221C2.05928 36.9232 1.34702 36.6282 0.821693 36.1038C0.296362 35.5794 0.000857887 34.8684 0 34.1268V2.79722C0.000857887 2.05562 0.296362 1.34463 0.821693 0.820231C1.34702 0.295835 2.05928 0.000856361 2.80221 0H95.838C96.5809 0.000856361 97.2931 0.295835 97.8185 0.820231C98.3438 1.34463 98.6393 2.05562 98.6402 2.79722V34.1268C98.6393 34.8684 98.3438 35.5794 97.8185 36.1038C97.2931 36.6282 96.5809 36.9232 95.838 36.9241Z",
    fill: "#3B6CCF",
    stroke: "#1D1F2A",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5841 9.51056H15.2206C14.8625 9.51056 14.5723 9.80029 14.5723 10.1577V11.6607C14.5723 12.0181 14.8625 12.3078 15.2206 12.3078H38.5841C38.9421 12.3078 39.2324 12.0181 39.2324 11.6607V10.1577C39.2324 9.80029 38.9421 9.51056 38.5841 9.51056Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7389 12.8672C72.6675 12.8672 73.4203 12.1158 73.4203 11.1889C73.4203 10.262 72.6675 9.51056 71.7389 9.51056C70.8104 9.51056 70.0576 10.262 70.0576 11.1889C70.0576 12.1158 70.8104 12.8672 71.7389 12.8672Z",
    fill: "#1D1F2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3425 12.8672C78.271 12.8672 79.0238 12.1158 79.0238 11.1889C79.0238 10.262 78.271 9.51056 77.3425 9.51056C76.4139 9.51056 75.6611 10.262 75.6611 11.1889C75.6611 12.1158 76.4139 12.8672 77.3425 12.8672Z",
    fill: "#1D1F2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9479 12.8672C83.8765 12.8672 84.6293 12.1158 84.6293 11.1889C84.6293 10.262 83.8765 9.51056 82.9479 9.51056C82.0194 9.51056 81.2666 10.262 81.2666 11.1889C81.2666 12.1158 82.0194 12.8672 82.9479 12.8672Z",
    fill: "#1D1F2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorComputer);
export default __webpack_public_path__ + "static/media/error-computer.49ac3bdbbe30fe948ceb6d4de817bfd4.svg";
export { ForwardRef as ReactComponent };